import { ArrowUturnRightIcon } from '@heroicons/react/16/solid'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function BackButton({ onClick }) {
  const { t } = useTranslation()
  return (
    <button
      onClick={onClick}
      className='flex flex-row rounded-lg border border-lightGrey p-2'
    >
      <ArrowUturnRightIcon className='mr-2 size-4 text-buttonSecondaryBlue' />
      <span className='text-sm font-medium'>{t('common.back')}</span>
    </button>
  )
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired
}
